import { DragDropModule } from '@angular/cdk/drag-drop';
import { DatePipe } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { enableProdMode, importProvidersFrom } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { NGX_MAT_DATE_FORMATS, NgxMatDateAdapter } from '@ngxmc/datetime-picker';
import { FileUploadModule } from 'ng2-file-upload';
import { CookieService } from 'ngx-cookie-service';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { QuillModule } from 'ngx-quill';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ToastrModule } from 'ngx-toastr';
import { AppComponent } from './app/app.component';
import { CustomDatetimeAdapter } from './app/core/custom-datetime-adapter';
import { CustomHttpInterceptor } from './app/core/custom-http-Interceptor';
import { FilterService } from './app/services/filter-service';
import { environment } from './environments/environment';
import { AppRoutingModule } from './modules/app-routing.module';
import { MY_FORMATS_DATE, MY_FORMATS_DATETIME } from './modules/date-formatting.module';

if (environment.production) {
    enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(
            BrowserModule,
            AppRoutingModule,
            NgxSpinnerModule,
            FormsModule,
            ReactiveFormsModule,
            MatFormFieldModule,
            MatProgressSpinnerModule,
            MatIconModule,
            MatTableModule,
            MatDatepickerModule,
            MatSelectModule,
            MatCheckboxModule,
            MatInputModule,
            MatSortModule,
            MatCardModule,
            MatButtonModule,
            MatDialogModule,
            MatTooltipModule,
            MatExpansionModule,
            MatTabsModule,
            MatListModule,
            MatMenuModule,
            MatChipsModule,
            MatAutocompleteModule,
            DragDropModule,
            FileUploadModule,
            AngularEditorModule,
            InfiniteScrollModule,
            ToastrModule.forRoot({
                timeOut: 5000,
                positionClass: 'toast-bottom-right',
                preventDuplicates: true,
            }),
            FontAwesomeModule,
            MatNativeDateModule,
            QuillModule.forRoot()
        ),
        CookieService,
        { provide: 'FilterServiceInterface', useClass: FilterService },
        { provide: HTTP_INTERCEPTORS, useClass: CustomHttpInterceptor, multi: true },
        { provide: MAT_DATE_LOCALE, useValue: 'fr' },
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS_DATE },
        { provide: NGX_MAT_DATE_FORMATS, useValue: MY_FORMATS_DATETIME },
        { provide: NgxMatDateAdapter, useClass: CustomDatetimeAdapter },
        { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { floatLabel: 'auto', appearance: 'fill' } },
        DatePipe,
        provideAnimations(),
        provideHttpClient(withInterceptorsFromDi()),
    ],
}).catch((err) => console.error(err));
